import { ProtocolFormData } from "./schema"

export const DEFAULT_FORM_VALUES: ProtocolFormData = {
  study_title: "",
  sponsor: "",
  phase: "",
  parts: [{ name: "Main Study", periods: [], assessments: [] }],
}

export const generateVisitId = () => `v${Date.now()}-${Math.random().toString(36).slice(2, 7)}`

// Single-part protocols keep the bare "Schedule of Activities" heading; multi-part ones label each
// grid with its part name so every part is distinguishable.
export const partSectionLabel = (name: string | undefined, index: number, total: number) =>
  total <= 1 ? "Schedule of Activities" : `Schedule of Activities — ${name || `Part ${index + 1}`}`
